define('display/layers/animator',['leaflet'], function(L) {
    return {
        loadAnimationFactory: function(layer) {
            return function() {
                var opacity = 'opacity',
                    back = layer._bgBuffer;
                back.style[L.DomUtil.TRANSITION] = opacity + ' 10';
                back.style[opacity] = 0.1;
                layer._tileContainer.style[opacity] = layer.options.opacity;
            }
        }
    }
});

